// Sprung aus der To-do-Liste zu einem Eintrag (Objekt, Ort, Insel, Seite, Anlage, Region): Ziel in sessionStorage merken, Ziel-Tab holt es sich beim Laden ab.
const KEY = "ph_admin_focus";

export const setAdminFocus = (kind, key) => {
  try { sessionStorage.setItem(KEY, JSON.stringify({ kind, key })); } catch { /* ignore */ }
};

/** Liefert den Schlüssel, wenn ein Sprungziel dieser Art wartet, und löscht es. */
export const takeAdminFocus = (kind) => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw);
    if (v.kind !== kind) return null;
    sessionStorage.removeItem(KEY);
    return v.key;
  } catch { return null; }
};

export const NOTE_TAB = { property: "properties", place: "places", island: "islands", page: "pages", tip: "tips", complex: "complexes", region: "regions" };
